import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { App } from "@/App";
import { AuthProvider } from "@/auth/AuthProvider";
import "./index.css";
import { openDatePickersOnClick } from "@/lib/date-click";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Portal users are casual visitors (not all-day workstations). Less
      // aggressive refetch than the staff app — leave defaults sticky.
      refetchOnWindowFocus: false,
      staleTime: 60_000,
      retry: (failureCount, err) => {
        const e = err as { status?: number };
        if (e?.status === 401) return false;
        return failureCount < 2;
      },
    },
  },
});

// The whole date box opens the calendar (Stephanie 2026-10-26).
openDatePickersOnClick(document);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
